var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	413: () => (loadStrictSingletonVersion("default", "@ngrx/signals", false, [1,19,0,1], () => (__webpack_require__.e(4184).then(() => (() => (__webpack_require__(/*! @ngrx/signals */ 61803))))))),
	9015: () => (loadStrictSingletonVersion("default", "rxjs", false, [2,7,8,1], () => (__webpack_require__.e(845).then(() => (() => (__webpack_require__(/*! rxjs */ 80845))))))),
	29661: () => (loadStrictSingletonVersion("default", "@angular/core/rxjs-interop", false, [1,19,2,18], () => (__webpack_require__.e(6693).then(() => (() => (__webpack_require__(/*! @angular/core/rxjs-interop */ 49074))))))),
	48389: () => (loadStrictSingletonVersion("default", "@angular/core", false, [1,19,2,18], () => (__webpack_require__.e(7580).then(() => (() => (__webpack_require__(/*! @angular/core */ 37580))))))),
	49859: () => (loadStrictSingletonVersion("default", "@ngrx/signals/entities", false, [1,19,0,1], () => (__webpack_require__.e(7290).then(() => (() => (__webpack_require__(/*! @ngrx/signals/entities */ 74909))))))),
	76659: () => (loadStrictSingletonVersion("default", "@angular/common/http", false, [1,19,2,18], () => (__webpack_require__.e(8824).then(() => (() => (__webpack_require__(/*! @angular/common/http */ 46443))))))),
	91511: () => (loadStrictSingletonVersion("default", "@angular/common", false, [1,19,2,18], () => (__webpack_require__.e(7935).then(() => (() => (__webpack_require__(/*! @angular/common */ 60316))))))),
	57167: () => (loadStrictSingletonVersion("default", "rxjs/operators", false, [2,7,8,1], () => (__webpack_require__.e(8219).then(() => (() => (__webpack_require__(/*! rxjs/operators */ 98219))))))),
	80521: () => (loadStrictSingletonVersion("default", "@angular/forms", false, [1,19,2,18], () => (__webpack_require__.e(2075).then(() => (() => (__webpack_require__(/*! @angular/forms */ 34456))))))),
	66691: () => (loadStrictSingletonVersion("default", "@angular/core/primitives/signals", false, [1,19,2,18], () => (__webpack_require__.e(8070).then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 85689))))))),
	80839: () => (loadStrictSingletonVersion("default", "@angular/core/primitives/di", false, [1,19,2,18], () => (() => (__webpack_require__(/*! @angular/core/primitives/di */ 52867))))),
	1420: () => (loadStrictSingletonVersion("default", "@angular/cdk/platform", false, [1,19,2,19], () => (__webpack_require__.e(80).then(() => (() => (__webpack_require__(/*! @angular/cdk/platform */ 17699))))))),
	18298: () => (loadStrictSingletonVersion("default", "@angular/cdk/private", false, [1,19,2,19], () => (__webpack_require__.e(1608).then(() => (() => (__webpack_require__(/*! @angular/cdk/private */ 9227))))))),
	53140: () => (loadStrictSingletonVersion("default", "@angular/cdk/a11y", false, [1,19,2,19], () => (__webpack_require__.e(9721).then(() => (() => (__webpack_require__(/*! @angular/cdk/a11y */ 72102))))))),
	64788: () => (loadStrictSingletonVersion("default", "@angular/cdk/bidi", false, [1,19,2,19], () => (__webpack_require__.e(1299).then(() => (() => (__webpack_require__(/*! @angular/cdk/bidi */ 63680))))))),
	74924: () => (loadStrictSingletonVersion("default", "@angular/cdk/coercion", false, [1,19,2,19], () => (__webpack_require__.e(433).then(() => (() => (__webpack_require__(/*! @angular/cdk/coercion */ 2814))))))),
	11288: () => (loadStrictSingletonVersion("default", "@angular/cdk/keycodes", false, [1,19,2,19], () => (__webpack_require__.e(4879).then(() => (() => (__webpack_require__(/*! @angular/cdk/keycodes */ 74879))))))),
	25600: () => (loadStrictSingletonVersion("default", "@angular/cdk/overlay", false, [1,19,2,19], () => (__webpack_require__.e(9189).then(() => (() => (__webpack_require__(/*! @angular/cdk/overlay */ 81570))))))),
	29890: () => (loadStrictSingletonVersion("default", "@angular/cdk/observers/private", false, [1,19,2,19], () => (__webpack_require__.e(996).then(() => (() => (__webpack_require__(/*! @angular/cdk/observers/private */ 98615))))))),
	30734: () => (loadStrictSingletonVersion("default", "@angular/cdk/scrolling", false, [1,19,2,19], () => (__webpack_require__.e(2356).then(() => (() => (__webpack_require__(/*! @angular/cdk/scrolling */ 79975))))))),
	50568: () => (loadStrictSingletonVersion("default", "@angular/cdk/portal", false, [1,19,2,19], () => (__webpack_require__.e(6787).then(() => (() => (__webpack_require__(/*! @angular/cdk/portal */ 9168))))))),
	18116: () => (loadStrictSingletonVersion("default", "@angular/cdk/dialog", false, [1,19,2,19], () => (__webpack_require__.e(1101).then(() => (() => (__webpack_require__(/*! @angular/cdk/dialog */ 93482))))))),
	5130: () => (loadStrictSingletonVersion("default", "@angular/cdk/observers", false, [1,19,2,19], () => (__webpack_require__.e(1920).then(() => (() => (__webpack_require__(/*! @angular/cdk/observers */ 39539))))))),
	53446: () => (loadStrictSingletonVersion("default", "@angular/platform-browser", false, [1,19,2,18], () => (__webpack_require__.e(8055).then(() => (() => (__webpack_require__(/*! @angular/platform-browser */ 80436))))))),
	25772: () => (loadStrictSingletonVersion("default", "@angular/cdk/text-field", false, [1,19,2,19], () => (__webpack_require__.e(7559).then(() => (() => (__webpack_require__(/*! @angular/cdk/text-field */ 69940))))))),
	1474: () => (loadStrictSingletonVersion("default", "@angular/cdk/collections", false, [1,19,2,19], () => (__webpack_require__.e(370).then(() => (() => (__webpack_require__(/*! @angular/cdk/collections */ 37989))))))),
	15262: () => (loadStrictSingletonVersion("default", "@angular/cdk/stepper", false, [1,19,2,19], () => (__webpack_require__.e(6366).then(() => (() => (__webpack_require__(/*! @angular/cdk/stepper */ 63985))))))),
	91899: () => (loadStrictSingletonVersion("default", "@angular/animations/browser", false, [1,19,2,18], () => (__webpack_require__.e(655).then(() => (() => (__webpack_require__(/*! @angular/animations/browser */ 10655))))))),
	28619: () => (loadStrictSingletonVersion("default", "@angular/router", false, [1,19,2,18], () => (__webpack_require__.e(2691).then(() => (() => (__webpack_require__(/*! @angular/router */ 95072))))))),
	34593: () => (loadStrictSingletonVersion("default", "@azure/msal-browser", false, [1,4,28,1], () => (__webpack_require__.e(1721).then(() => (() => (__webpack_require__(/*! @azure/msal-browser */ 74102))))))),
	9473: () => (loadStrictSingletonVersion("default", "@microsoft/applicationinsights-angularplugin-js", false, [1,15,3,5], () => (__webpack_require__.e(2022).then(() => (() => (__webpack_require__(/*! @microsoft/applicationinsights-angularplugin-js */ 59641))))))),
	26906: () => (loadStrictSingletonVersion("default", "@angular/material/progress-spinner", false, [1,19,2,19], () => (__webpack_require__.e(8753).then(() => (() => (__webpack_require__(/*! @angular/material/progress-spinner */ 41134))))))),
	27446: () => (loadStrictSingletonVersion("default", "@angular/material/checkbox", false, [1,19,2,19], () => (__webpack_require__.e(4643).then(() => (() => (__webpack_require__(/*! @angular/material/checkbox */ 97024))))))),
	37999: () => (load("default", "@my-ul/common/standalone", false, () => (__webpack_require__.e(7256).then(() => (() => (__webpack_require__(/*! @my-ul/common/standalone */ 97256))))))),
	38430: () => (loadStrictSingletonVersion("default", "@azure/msal-angular", false, [1,4,0,25], () => (__webpack_require__.e(1034).then(() => (() => (__webpack_require__(/*! @azure/msal-angular */ 8653))))))),
	38745: () => (loadStrictSingletonVersion("default", "@angular/animations", false, [1,19,2,18], () => (__webpack_require__.e(7172).then(() => (() => (__webpack_require__(/*! @angular/animations */ 47172))))))),
	42278: () => (loadStrictSingletonVersion("default", "@angular/material/icon", false, [1,19,2,19], () => (__webpack_require__.e(1459).then(() => (() => (__webpack_require__(/*! @angular/material/icon */ 93840))))))),
	45962: () => (loadStrictSingletonVersion("default", "@angular/material/input", false, [1,19,2,19], () => (__webpack_require__.e(7922).then(() => (() => (__webpack_require__(/*! @angular/material/input */ 95541))))))),
	62673: () => (load("default", "@my-ul/tod-angular-client", false, () => (__webpack_require__.e(6132).then(() => (() => (__webpack_require__(/*! @my-ul/tod-angular-client */ 73751))))))),
	65986: () => (loadStrictSingletonVersion("default", "@angular/material/form-field", false, [1,19,2,19], () => (__webpack_require__.e(2569).then(() => (() => (__webpack_require__(/*! @angular/material/form-field */ 24950))))))),
	75852: () => (loadStrictSingletonVersion("default", "@angular/material/dialog", false, [1,19,2,19], () => (__webpack_require__.e(4968).then(() => (() => (__webpack_require__(/*! @angular/material/dialog */ 12587))))))),
	79666: () => (loadStrictSingletonVersion("default", "@microsoft/applicationinsights-web", false, [1,3,3,5], () => (__webpack_require__.e(5205).then(() => (() => (__webpack_require__(/*! @microsoft/applicationinsights-web */ 75205))))))),
	84404: () => (loadStrictSingletonVersion("default", "@angular/material/button", false, [1,19,2,19], () => (__webpack_require__.e(6556).then(() => (() => (__webpack_require__(/*! @angular/material/button */ 84175))))))),
	34037: () => (load("default", "@my-ul/common/telemetry", false, () => (__webpack_require__.e(803).then(() => (() => (__webpack_require__(/*! @my-ul/common/telemetry */ 13184))))))),
	94873: () => (loadStrictSingletonVersion("default", "ag-grid-community", false, [1,35,0,0], () => (__webpack_require__.e(2176).then(() => (() => (__webpack_require__(/*! ag-grid-community */ 72176)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"80": [
		91511
	],
	"316": [
		9015,
		48389
	],
	"370": [
		9015
	],
	"436": [
		48389,
		76659,
		91511
	],
	"1034": [
		9015,
		28619,
		34593,
		57167
	],
	"1101": [
		91511
	],
	"1134": [
		48389,
		53140,
		64788,
		91511
	],
	"1299": [
		91511
	],
	"1423": [
		1420,
		1474,
		18298,
		48389,
		53140,
		64788,
		74924,
		80521
	],
	"1459": [
		53140,
		53446,
		57167,
		64788
	],
	"1570": [
		9015,
		48389,
		57167,
		91511
	],
	"1803": [
		48389
	],
	"2075": [
		9015,
		57167,
		91511
	],
	"2102": [
		9015,
		48389,
		57167,
		91511
	],
	"2265": [
		1420,
		9015,
		11288,
		18298,
		48389,
		53140,
		57167,
		64788,
		74924,
		91511
	],
	"2356": [
		91511
	],
	"2569": [
		1420,
		5130,
		29890,
		53140,
		57167,
		64788,
		74924
	],
	"2587": [
		9015,
		11288,
		18116,
		25600,
		30734,
		48389,
		50568,
		53140,
		57167,
		64788,
		74924
	],
	"2691": [
		9015,
		53446,
		57167,
		91511
	],
	"2814": [
		48389
	],
	"3036": [
		48389
	],
	"3184": [
		48389,
		91511
	],
	"3482": [
		9015,
		48389,
		57167,
		91511
	],
	"3680": [
		48389,
		91511
	],
	"3751": [
		9015,
		28619,
		29661,
		48389,
		76659,
		91511
	],
	"3835": [
		48389,
		91511,
		91899
	],
	"3840": [
		9015,
		48389,
		53140,
		53446,
		57167,
		64788,
		76659,
		91511
	],
	"3985": [
		9015,
		48389,
		57167,
		80521,
		91511
	],
	"4175": [
		1420,
		18298,
		48389,
		53140,
		64788,
		74924,
		91511
	],
	"4241": [
		1420,
		9015,
		15262,
		18298,
		48389,
		50568,
		53140,
		53446,
		57167,
		64788,
		74924,
		76659,
		91511
	],
	"4358": [
		1420,
		9015,
		11288,
		18298,
		25600,
		29890,
		30734,
		48389,
		50568,
		53140,
		57167,
		64788,
		74924,
		80521,
		91511
	],
	"4456": [
		9015,
		48389,
		57167,
		91511
	],
	"4643": [
		1420,
		18298,
		53140,
		64788,
		74924,
		80521
	],
	"4791": [
		48389,
		91511
	],
	"4909": [
		413,
		48389
	],
	"4950": [
		1420,
		5130,
		9015,
		29890,
		48389,
		53140,
		57167,
		64788,
		74924,
		91511
	],
	"4968": [
		11288,
		18116,
		25600,
		30734,
		50568,
		53140,
		57167,
		64788,
		74924
	],
	"5072": [
		9015,
		48389,
		53446,
		57167,
		91511
	],
	"5214": [
		413,
		9015,
		29661,
		48389,
		49859,
		76659,
		91511
	],
	"5541": [
		1420,
		5130,
		9015,
		25772,
		29890,
		48389,
		53140,
		57167,
		64788,
		74924,
		80521,
		91511
	],
	"5635": [
		28619,
		34037,
		37999,
		48389,
		53446,
		91511
	],
	"6132": [
		9015,
		28619,
		29661
	],
	"6158": [
		48389,
		53140,
		64788
	],
	"6366": [
		80521
	],
	"6443": [
		9015,
		48389,
		57167
	],
	"6556": [
		1420,
		18298,
		53140,
		64788,
		74924
	],
	"6693": [
		57167
	],
	"6787": [
		91511
	],
	"7024": [
		1420,
		18298,
		48389,
		53140,
		64788,
		74924,
		80521
	],
	"7256": [
		9015,
		9473,
		26906,
		27446,
		29661,
		34593,
		38430,
		38745,
		42278,
		45962,
		62673,
		65986,
		75852,
		76659,
		79666,
		84404
	],
	"7453": [
		94873
	],
	"7580": [
		9015,
		57167,
		66691,
		80839
	],
	"7699": [
		48389,
		91511
	],
	"7832": [
		9015,
		9473,
		26906,
		27446,
		28619,
		29661,
		34593,
		37999,
		38430,
		38745,
		42278,
		45962,
		48389,
		62673,
		65986,
		75852,
		76659,
		79666,
		84404,
		91511
	],
	"7922": [
		1420,
		5130,
		25772,
		29890,
		53140,
		57167,
		64788,
		74924,
		80521
	],
	"7935": [
		9015
	],
	"7989": [
		9015,
		48389
	],
	"8055": [
		76659
	],
	"8615": [
		9015,
		48389,
		57167
	],
	"8653": [
		9015,
		28619,
		34593,
		48389,
		57167,
		91511
	],
	"8753": [
		53140,
		64788
	],
	"8824": [
		9015,
		57167
	],
	"9074": [
		9015,
		48389,
		57167
	],
	"9168": [
		48389,
		91511
	],
	"9189": [
		91511
	],
	"9227": [
		48389
	],
	"9539": [
		9015,
		48389,
		57167
	],
	"9641": [
		28619,
		48389
	],
	"9672": [
		48389,
		94873
	],
	"9721": [
		9015,
		57167,
		91511
	],
	"9940": [
		9015,
		48389,
		57167,
		91511
	],
	"9975": [
		9015,
		48389,
		57167,
		91511
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}